"use client";

import { useState } from "react";
import { Container, Box, Fade } from "@mui/material";
import LoginForm from "../components/auth/LoginForm";
import SignupForm from "../components/auth/SignupForm";

function AuthPage() {
  const [isLogin, setIsLogin] = useState(true);

  const toggleMode = () => {
    setIsLogin(!isLogin);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Box
        sx={{
          // minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.default", // Consistent background
          p: 0, // Add some padding to prevent edge touching on small screens
        }}
      >
        <Fade in={true} timeout={500}>
          <Box sx={{ width: "100%" }}>
            {isLogin ? (
              <LoginForm onToggleMode={toggleMode} />
            ) : (
              <SignupForm onToggleMode={toggleMode} />
            )}
          </Box>
        </Fade>
      </Box>
    </Container>
  );
}

export default AuthPage;
